import { useEffect, useRef } from 'react';
import { DeviceFilterOption, DeviceFilterOptions } from '@/api';
import { useOpenApi } from '../providers/open-api-provider';
import { DEVICE_FILTER_OPTIONS_QUERY_KEY } from './common-query-keys';
import {
    FILTER_OPTIONS_PAGE_SIZE,
    FetchFilterOptionsResult,
    FetchScopedFilterOptionsQuery,
    useFetchFilterOptionsPages
} from './filter-options-paging';

/**
 * The devices a viewer can filter or pick from, narrowed to the teams already
 * chosen so the list matches what the rest of the filter is showing.
 */
export function useFetchDeviceFilterOptions(
    query: FetchScopedFilterOptionsQuery
): FetchFilterOptionsResult<DeviceFilterOption> {
    const { companyId, search, teamIds, enabled } = query;

    const { openApi } = useOpenApi();
    const openApiRef = useRef(openApi);
    useEffect(() => {
        openApiRef.current = openApi;
    });

    return useFetchFilterOptionsPages<DeviceFilterOption>(
        [DEVICE_FILTER_OPTIONS_QUERY_KEY, { companyId, search, teamIds }],
        enabled,
        (offset) =>
            openApiRef.current.filters
                .getDeviceFilterOptions({
                    companyId,
                    limit: FILTER_OPTIONS_PAGE_SIZE,
                    offset,
                    search: search || undefined,
                    teamIds: teamIds.length > 0 ? teamIds : undefined
                })
                .then(
                    (response): DeviceFilterOptions =>
                        response.data.data.options
                )
    );
}
